(() => {
  if (customElements.get('splus-delivery-estimate')) return;

  const getBerlinState = (date) => {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    return {
      date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12)),
      hour: Number(values.hour),
      minute: Number(values.minute),
    };
  };

  const addCalendarDays = (date, days) => {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  };

  const dateKey = (date) => [
    date.getUTCFullYear(),
    String(date.getUTCMonth() + 1).padStart(2, '0'),
    String(date.getUTCDate()).padStart(2, '0'),
  ].join('-');

  const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = ((19 * a) + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + (2 * e) + (2 * i) - h - k) % 7;
    const m = Math.floor((a + (11 * h) + (22 * l)) / 451);
    const month = Math.floor((h + l - (7 * m) + 114) / 31);
    const day = ((h + l - (7 * m) + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day, 12));
  };

  const nurembergHolidays = (year) => {
    const easter = easterSunday(year);
    return new Set([
      `${year}-01-01`,
      `${year}-01-06`,
      dateKey(addCalendarDays(easter, -2)),
      dateKey(addCalendarDays(easter, 1)),
      `${year}-05-01`,
      dateKey(addCalendarDays(easter, 39)),
      dateKey(addCalendarDays(easter, 50)),
      dateKey(addCalendarDays(easter, 60)),
      `${year}-10-03`,
      `${year}-11-01`,
      `${year}-12-25`,
      `${year}-12-26`,
    ]);
  };

  const isWorkingDay = (date) => {
    const weekday = date.getUTCDay();
    return weekday !== 0 && weekday !== 6 && !nurembergHolidays(date.getUTCFullYear()).has(dateKey(date));
  };

  const nextWorkingDay = (date) => {
    let result = new Date(date.getTime());
    do {
      result = addCalendarDays(result, 1);
    } while (!isWorkingDay(result));
    return result;
  };

  const addWorkingDays = (date, days) => {
    const result = new Date(date.getTime());
    let remaining = days;
    while (remaining > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isWorkingDay(result)) remaining -= 1;
    }
    return result;
  };

  const formatDate = (date, locale) => new Intl.DateTimeFormat(locale, {
    timeZone: 'UTC',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  }).format(date);

  customElements.define('splus-delivery-estimate', class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const minDays = Number.parseInt(this.dataset.minDays, 10);
      const maxDays = Number.parseInt(this.dataset.maxDays, 10);
      const fallback = this.querySelector('[data-delivery-fallback]');
      const enhanced = this.querySelector('[data-delivery-enhanced]');
      const dateRange = this.querySelector('[data-delivery-date-range]');

      if (!this.countryTriggerBound) {
        this.addEventListener('click', this.handleCountryTrigger.bind(this));
        this.countryTriggerBound = true;
      }

      if (
        !Number.isInteger(minDays)
        || !Number.isInteger(maxDays)
        || minDays < 0
        || maxDays < minDays
        || !fallback
        || !enhanced
        || !dateRange
      ) return;

      const locale = this.dataset.locale || document.documentElement.lang || 'en';
      const berlin = getBerlinState(new Date());
      const cutoffHour = this.dataset.countryCode === 'DE' ? 14 : 12;
      let startDate = berlin.date;
      if (!isWorkingDay(startDate) || berlin.hour >= cutoffHour) startDate = nextWorkingDay(startDate);
      const earliest = addWorkingDays(startDate, minDays);
      const latest = addWorkingDays(startDate, maxDays);
      dateRange.textContent = dateKey(earliest) === dateKey(latest)
        ? formatDate(earliest, locale)
        : `${formatDate(earliest, locale)} - ${formatDate(latest, locale)}`;
      fallback.hidden = true;
      enhanced.hidden = false;
    }

    handleCountryTrigger(event) {
      const trigger = event.target.closest?.('[data-delivery-country-trigger]');
      if (!trigger) return;
      event.preventDefault?.();

      if (window.matchMedia('(min-width: 990px)').matches) {
        document.querySelector('.strix-main-header #AnnouncementCountryForm button.localization-form__select')?.click();
        return;
      }

      const localizationForm = this.querySelector('[data-delivery-country-localization]');
      if (!localizationForm) return;
      localizationForm.returnFocusTo = trigger;
      localizationForm.querySelector('button.localization-form__select')?.click();
    }
  });
})();
